'use es6';

import Company from 'customer-data-objects/company/CompanyRecord';
import PropTypes from 'prop-types';
const CompanyType = PropTypes.instanceOf(Company);
export default CompanyType;